import { DjangoEmployee, Employee, parseEmployee } from '../employee';
import { DjangoInvoice, Invoice } from './invoice.model';

export class EmployeeInvoice extends Invoice {
  employee: Employee;

  constructor(data: string | EmployeeInvoice | DjangoEmployeeInvoice = {}) {
    super(data);

    if (typeof data !== 'string') {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export function parseEmployeeInvoice(val) {
  if (val) {
    return new EmployeeInvoice(val);
  } else {
    return undefined;
  }
}

///////////////////
// DJANGO SUPPOT //
///////////////////
export interface DjangoEmployeeInvoice extends DjangoInvoice {
  employee?: string | DjangoEmployee;
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(
  instance: EmployeeInvoice,
  data: EmployeeInvoice | DjangoEmployeeInvoice,
) {
  instance.employee = parseEmployee(data.employee);
}
